export const getAbruzzesData = () => ({
  name: "Abruzzes",
  country: "Italie",
  description: "Les Abruzzes sont une région viticole du centre de l'Italie, s'étendant des Apennins à l'Adriatique. Cette région produit principalement des vins rouges structurés et des vins blancs aromatiques, avec une forte identité montagneuse et côtière.",
  type: "region",
  mapAreas: [
    { region: "Abruzzes", x: 48, y: 45, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "32,000 ha",
    production: "2.1 million hectolitres",
    appellations: "8 DOC et 1 DOCG",
    provinces: "4 provinces",
    exportPercentage: "20%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence continentale, étés chauds et hivers froids",
    soil: "Sols très variés : calcaire, argile, sable, flysch",
    viticulture: "Viticulture traditionnelle, vignobles en coteaux et en plaine"
  },
  wineStyles: {
    red: "Vins rouges structurés et tanniques, avec une forte identité cépage",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sweet: "Vins doux traditionnels, vendanges tardives"
  },
  history: "La viticulture dans les Abruzzes remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la région est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine abruzzaise, viandes rouges, poissons, charcuteries, cuisine montagneuse",
  subregions: {
    "montepulciano-dabruzzo": {
      name: "Montepulciano d'Abruzzo",
      description: "Région prestigieuse produisant des vins rouges structurés et tanniques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "montepulciano-dabruzzo": "Vins rouges structurés et tanniques",
        "montepulciano-dabruzzo-colline-teramane": "Vins rouges puissants et concentrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine abruzzaise"
    },
    "trebbiano-dabruzzo": {
      name: "Trebbiano d'Abruzzo",
      description: "Région produisant des vins blancs secs et aromatiques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Trebbiano d'Abruzzo", "Pecorino", "Passerina"]
      },
      wineStyles: {
        "trebbiano-dabruzzo": "Vins blancs secs et aromatiques",
        "pecorino-teramano": "Vins blancs secs et complexes"
      },
      foodPairing: "Poissons, fruits de mer, volailles, fromages, cuisine côtière"
    },
    "controguerra": {
      name: "Controguerra",
      description: "Région produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese", "Cabernet Sauvignon"],
        white: ["Trebbiano d'Abruzzo", "Pecorino", "Chardonnay"]
      },
      wineStyles: {
        "controguerra-rosso": "Vins rouges structurés et équilibrés",
        "controguerra-bianco": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "orona": {
      name: "Ortona",
      description: "Région côtière produisant des vins rouges et blancs de qualité, avec une forte identité côtière.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols sableux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese"],
        white: ["Trebbiano d'Abruzzo", "Pecorino"]
      },
      wineStyles: {
        "orona-rosso": "Vins rouges fruités et équilibrés",
        "orona-bianco": "Vins blancs secs et frais"
      },
      foodPairing: "Poissons, fruits de mer, volailles, cuisine côtière"
    }
  }
}); 